import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_LinkedHashSet(_this__u8e3s4) {
}
var LinkedHashSetClass;
function LinkedHashSet() {
  if (LinkedHashSetClass === VOID) {
    class $ extends HashSet() {
      static s2() {
        var $this = this.ga();
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static c3(elements) {
        var $this = this.ha(elements);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static hc(initialCapacity, loadFactor) {
        var $this = this.ja(initialCapacity, loadFactor);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static d2(initialCapacity) {
        return this.hc(initialCapacity, 1.0);
      }
      o6() {
        return this.d3_1.q9();
      }
    }
    initMetadataForClass($, 'LinkedHashSet', $.s2, VOID, [KtMutableSet()]);
    LinkedHashSetClass = $;
  }
  return LinkedHashSetClass;
}
//region block: exports
export {
  LinkedHashSet as LinkedHashSet2tkztfx86kyx2,
};
//endregion

//# sourceMappingURL=LinkedHashSet.mjs.map
